(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.addEventListener('gender:changed', function (event) {
    var gender = event.detail && event.detail.gender;
    if (gender !== 'man' && gender !== 'woman') return;

    document.querySelectorAll('[data-section-type="featured-collections"]').forEach(function (sectionEl) {
      var tab = sectionEl.querySelector('[data-action="toggle-tab"][data-gender-tab="' + gender + '"]');
      if (tab && !tab.classList.contains('is-active')) {
        tab.click();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
